export const PROPULSION = "propulsion"
export const LIGHT_SAIL = "light_sail"
export const YACHT = "yacht"
export const MOTOR_BOAT = "motor_boat"
